
  import { computed, defineComponent } from 'vue';
  import './list.scss';

  /**
   * List
   * 
   * @example
   * <code>import TpxList from '@manifesto-tech/tpximpact-design-system/components/atoms/list/list.vue'</code>
   * 
   * A custom template can be passed through to the list to render components within each list element:
   * 
   * <code>&lt;template v-slot:item="{ item }"&gt; ... &lt;/template&gt;</code>
   */
  export default defineComponent({
    name: 'TpxList',
    
    props: {
      /**
        * Array of items being passed into the list
        */
      items: {
        type: Array,
        required: true,
      },

      /**
        * The list variant, such as: `bullets`, 'unstyled', ...
        */
      variant: {
        type: String,
        validator: (value: string) => {
          return ['bullets', 'unstyled'].includes(value);
        },
      },
    },

    data() {
      return {
        classes: computed(() => ({
          [`a-list--${this.variant}`]: !!this.variant,
        })),
      };
    },
  });
